import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('sheet_rate', '/sheet_rates')
const reducer = generator.generate()

export default reducer
